import React from "react";
import {Card, CardContent, CardMedia, Typography, Container, Box} from '@mui/material';

const searchEngines = [
    {
        name: 'Google',
        image: 'searchEngins/new-google-logo.png',
        url: 'https://www.google.com',
    },
    {
        name: 'Instagram',
        image: 'searchEngins/new-instagram-logo.png',
        url: 'https://www.instagram.com',
    },
    {
        name: 'Youtube',
        image: 'searchEngins/new-youtube-logo.png',
        url: 'https://www.youtube.com',
    },
    {
        name: 'Facebook',
        image: 'searchEngins/new-facebook-logo.png',
        url: 'https://www.facebook.com',
    },
    {
        name: 'Naver',
        image: 'searchEngins/new-naver-logo.png',
        url: 'https://www.naver.com',
    },
    // {
    //     name: '다음',
    //     image: '/daum-logo.png',
    //     url: 'https://www.daum.net',
    // },
    // {
    //     name: '네이트',
    //     image: '/nate-logo.jpg',
    //     url: 'https://m.nate.com',
    // },
    // {
    //     name: 'zum',
    //     image: '/zum-logo.png',
    //     url: 'https://zum.com',
    // },
    // {
    //     name: '트위터',
    //     image: '/twitter-logo.png',
    //     url: 'https://twitter.com',
    // }
    {
        name: 'Kakao',
        image: 'searchEngins/new-kakao-logo.png',
        url: 'https://www.kakaocorp.com/page/service/service/KakaoTalk ',
    }
];

const SearchEngines: React.FC = () => {
    return (
        <Container style={{ maxWidth: '1190px', height: '56px', margin: '0 auto', padding: '0 50px', overflowX: 'auto', border: '1px solid #d3d3d3', borderRadius: '4px', marginBottom: '1rem' }}>
            <Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="space-between">
                {searchEngines.map((engine) => (
                    <Box key={engine.name} m={1} style={{ display: 'flex', alignItems: 'center' }}>
                        <Card onClick={() => window.open(engine.url, '_blank')} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }} elevation={0}>
                            <CardMedia
                                component="img"
                                image={engine.image}
                                alt={`${engine.name} logo`}
                                style={{ maxHeight: '32px', objectFit: 'cover', marginRight: '8px' }}
                            />
                            <Box style={{ flexBasis: 'calc(100% / 5 - 16px)', flexGrow: 1 }}>
                                <Typography variant="body1" style={{ fontSize: '1.5rem' }}>{engine.name}</Typography>
                            </Box>
                        </Card>
                    </Box>
                ))}
            </Box>
        </Container>
    );
}

export default SearchEngines